import { fromJS } from 'immutable';

export const getLocalStorage = (item) => {
  try {
    const serializedState = localStorage.getItem(item);
    if(serializedState === null) {
      return undefined;
    }
    return fromJS(JSON.parse(serializedState));
  } catch (err) {
    return undefined;
  }
};

export const setLocalStorage = (item, state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(item, serializedState);
  } catch (err) {
    //ignore write errors
  }
};

export const deleteFromLocalStorage = (item) => {
  try {
    localStorage.removeItem(item);
  } catch (err) {

  }
};

export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (err) {
    // ignore
  }
};

export const loadState = (timeToExpire) => {
  try {
    const serializedState = localStorage.getItem('state');
    const updateTime = new Date(localStorage.getItem('updateTime')).getTime();

    const currentTime = new Date().getTime();

    if(timeToExpire && (serializedState === null || updateTime+timeToExpire < currentTime)){
      return undefined;
    }
    if(!timeToExpire && serializedState === null){
      return undefined;
    }
    return fromJS(JSON.parse(serializedState));
  }  catch(err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
    localStorage.setItem('updateTime', new Date());
  } catch (err) {
    // ignore
  }
};
